// @ts-nocheck
document.addEventListener("alpine:init", () => {
    /**
       * @param {{product: {selling_plan_allocations: Array<{selling_plan_id: number | null}>}}} product
    */
    Alpine.data("productForm", function ({ variant = {}, inCart = false }) {
      return {
        variant,
        sellingPlanId: null,
        isAddedToCart: false,
        maxQuantity: 99,
        formattedPrice: 0,
        cartItem: null,
        cartProduct: null,
        // R-TAP-EARLY, Codex round TAP-5 finding 2. THE DECLARED STATE NOW MATCHES
        // THE SERVED HTML, rather than matching it only by the time anything
        // reads it.
        //
        // These two used to be `false` and `true`, and the blocks that render the
        // buttons from the server were relying on `init()` running synchronously
        // before any descendant `x-show` was evaluated. That is true of Alpine
        // today, it was measured, and it is still the wrong thing to rest on: the
        // rule is that a server-rendered starting state mirrors its expression,
        // read out of the SERVED HTML. `inCart` is passed by the caller from the
        // same `cart | line_items_for` lookup the markup uses, so the data and
        // the document agree before a single directive runs.
        //
        // `loading` has no state to be in any more. Nothing sets it true; init()
        // and initCartItem() only ever set it false. It is kept because the
        // placeholder and both wrappers still read it.
        toggleQuantityBox: inCart,
        loading: false,
        totalPrice: 0,
        quantity: 1,
        pendingUpdate: false,
        queuedQuantity: null,
        optimisticAdd: false,

/**
 * Format price like Shopify's money filter
 * @param {number|string} cents - Price in cents or dollars
 * @param {string} format - Format string (default: '$[[amount]]')
 * @returns {string} Formatted price string
 */
formatMoney(cents, format = '$[[amount]]') {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  
  let value = '';
  const placeholderRegex = /\[\[\s*(\w+)\s*\]\]/;
  const formatString = format || '$[[amount]]';
  
  function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
    if (isNaN(number) || number == null) {
      return '0';
    }
    
    number = (number / 100.0).toFixed(precision);
    
    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const centsAmount = parts[1] ? (decimal + parts[1]) : '';
    
    return dollarsAmount + centsAmount;
  }
  
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  
  return formatString.replace(placeholderRegex, value);
},

        initCartItem(cartProduct) {
          this.loading = false;
          this.toggleQuantityBox = !!cartProduct;

          if (cartProduct) {
            this.quantity = cartProduct.quantity || 1;
            this.totalPrice = cartProduct.price * this.quantity;
          }
        },

        init() {
          this.sellingPlanId = this.handleSellingPlanChange(
            this.$store.cartDrawerStore.sellingPlan
          );

          this.cartProduct = this.getCartProduct(this.$store.cartDrawerStore.products) || null;
          this.loading = false;
          this.toggleQuantityBox = this.cartProduct !== null;

          if (this.cartProduct) {
            this.totalPrice = this.cartProduct.price * this.quantity;
          }

          this.$watch(
            () => this.$store.cartDrawerStore.sellingPlan, /** @param {number | null} sellingPlanId */
    (sellingPlanId) => {
              this.handleSellingPlanChange(sellingPlanId);
            }
          );

          this.$watch('$store.cartDrawerStore.products',(value, oldvalue)=>{
            this.cartProduct = this.getCartProduct(value) || null;
            this.loading = false;
            this.toggleQuantityBox = this.cartProduct !== null;
            if (this.cartProduct) {
              this.totalPrice = this.cartProduct.price * this.quantity;
            }
          });

          // R-TAP (17 Sep 2026): show the stepper on the TAP, not on the
          // response. `cart-add-start` and `cart-add-settle` are dispatched by
          // assets/product-form.js on the <product-form-component> this card's
          // x-data sits on, so $root hears both and no other card does.
          //
          // Bound here rather than with @cart-add-start in the markup because
          // six Liquid files mount productForm and they drifted apart last time
          // something was added to all of them.
          this.$root.addEventListener('cart-add-start', () => this.onAddStart());
          this.$root.addEventListener('cart-add-settle', (event) => this.onAddSettle(event));
        },

        /**
         * The add has left. Put the card into the state it will be in when it
         * lands, so the customer sees "1 in box" in the same frame as the tap
         * instead of ~700 ms later.
         */
        onAddStart() {
          if (this.toggleQuantityBox) return;

          this.optimisticAdd = true;
          this.quantity = 1;
          // The card's own JSON is trimmed to id and selling plans (see the
          // note in blocks/ctr-buy-buttons-v2.liquid), so the unit price comes
          // off the button's data-price rather than from a re-expanded variant.
          // Without it the stepper would read the default 0 for the length of
          // the round trip.
          const unitPrice = Number(
            /** @type {HTMLElement | null} */ (this.$root.querySelector('[data-price]'))?.dataset.price
          );
          this.totalPrice = Number.isFinite(unitPrice) ? unitPrice : this.totalPrice;
          this.toggleQuantityBox = true;
        },

        /**
         * Undo the optimistic flip if the add did not happen. Read back off the
         * store rather than trusting a watcher to have run: cartController
         * publishes the store update from inside add(), so the ordering between
         * that watcher and this handler is not something to rely on.
         *
         * Nothing is said to the customer here. Every failure that reaches this
         * point has already been surfaced once by cart-controller.js, and R89/
         * R90b exist because this file used to say it a second time.
         * @param {CustomEvent} event
         */
        onAddSettle(event) {
          if (!this.optimisticAdd) return;
          this.optimisticAdd = false;

          if (event?.detail?.ok) {
            // R-TAP, Codex round TAP-2 finding 1. Send the `+` the customer
            // pressed while the add was still out. The store now holds the line,
            // so getCartLineKey() can address it.
            const queued = this.queuedQuantity;
            this.queuedQuantity = null;
            if (queued == null) return;

            this.cartProduct = this.getCartProduct(this.$store.cartDrawerStore.products || []) || null;
            const serverQuantity = this.cartProduct?.quantity ?? 1;

            if (queued !== serverQuantity) {
              this.quantity = queued;
              this.updateCart();
            }
            return;
          }

          this.queuedQuantity = null;
          this.cartProduct = this.getCartProduct(this.$store.cartDrawerStore.products || []) || null;
          this.toggleQuantityBox = this.cartProduct !== null;
          this.quantity = this.cartProduct?.quantity ?? 1;
          this.totalPrice = (this.cartProduct?.price ?? 0) * this.quantity;
        },

        getCartProduct(products) {
          const cartProduct = products.find((product) => product.id === this.variant.id);
          if (cartProduct) {
            this.quantity = cartProduct.quantity || 1;
            this.totalPrice = cartProduct.price * this.quantity;
          }
          return cartProduct;
        },

        increaseQuantity() {
          if (this.quantity < this.maxQuantity) {
            this.quantity = this.quantity + 1;
          }
          this.updateCart();
        },
        decreaseQuantity() {
          if (this.quantity >= 1) {
            this.quantity = this.quantity - 1;
            this.updateCart();
          }
        },

        getCartLineKey() {
          // R57a: identify the basket row by the Shopify key Shopify itself
          // hands us, rather than by where it happens to sit in the list. List
          // positions shuffle every time another row goes away, so the old
          // count-from-the-top lookup could aim a change at whichever drink had
          // shuffled up into that slot.
          const products = this.$store.cartDrawerStore.products || [];
          return products.find((product) => product.id === this.variant.id)?.key || null;
        },

        disableQuantitySelector() {
          // this.$root.classList.add('disabled');
          this.$refs.ctrQuantityBox.classList.add('disabled');
        },

        enableQuantitySelector() {
          // this.$root.classList.remove('disabled');
          this.$refs.ctrQuantityBox.classList.remove('disabled');
        },

        async updateCart() {
          // R-TAP, Codex round TAP-2 finding 1. THE STEPPER IS ON SCREEN BEFORE
          // THE CART HAS A LINE FOR IT.
          //
          // onAddStart() shows it in the same frame as the tap, roughly 700 ms
          // before the add response puts the line in the store. A `+` in that
          // window used to fall straight into the no-key branch below: no request
          // sent, an error banner the customer had done nothing to deserve, and
          // the number snapping back to 1 when the store finally updated. Showing
          // the control early is only an improvement if it also WORKS early.
          //
          // Held here and replayed by onAddSettle(), which runs after the
          // controller has published the store update, so the key exists by then.
          if (this.optimisticAdd) {
            this.queuedQuantity = this.quantity;
            return;
          }

          // R57a: a second tap while one request was still in flight used to
          // fire a competing one, and the pair could settle out of order. That
          // is how a decrease straight after an increase went missing during
          // testing. Hold only the most recent target and replay it once the
          // outstanding request has landed.
          if (this.pendingUpdate) {
            this.queuedQuantity = this.quantity;
            return;
          }

          const lineKey = this.getCartLineKey();

          if (!lineKey) {
            // R57c: this used to return in silence. Visibility of the stepper
            // is computed when the store changes, but the key is read at click
            // time, so a morph that briefly empties the store leaves a live
            // control with nothing to address. Narrow, never observed, and
            // precisely the kind of thing that gets reported as "the button did
            // nothing" three weeks later with no trace of why.
            // R90b, Codex round 35 finding 11: the stepper re-enables and the
            // number sits there disagreeing with the cart, with nothing said.
            const error = new Error(
              `no cart line key for variant ${String(this.variant?.id)}; this change was not sent`
            );
            console.error('[product-card-alp]', error.message);
            window.ctrNotifyCartFailure?.(
              'Sorry, your basket could not be updated. Please try again.',
              'product-card-alp',
              error
            );
            this.enableQuantitySelector();
            return;
          }

          // Codex P2, R57c-1 review: the stepper has already incremented on
          // screen by the time we get here, so if the controller asset is
          // missing the call rejects, no request is ever sent, and the
          // displayed quantity sits there disagreeing with the cart until a
          // reload. cart-sections.js keeps a fallback for its own missing
          // global; this path had none. Note the guard has to sit ABOVE the
          // pendingUpdate flag, not below it - returning with that flag raised
          // would wedge every later tap into the queue branch.
          if (!window.cartController?.change) {
            const error = new Error(
              `cart-controller.js is not loaded; no cart request was sent for variant ${String(this.variant?.id)}`
            );
            console.error('[product-card-alp]', error.message);
            window.ctrNotifyCartFailure?.(
              'Sorry, your basket could not be updated. Please refresh the page and try again.',
              'product-card-alp',
              error
            );
            this.quantity = this.cartProduct?.quantity ?? this.quantity;
            this.enableQuantitySelector();
            return;
          }

          const committedQuantity = this.quantity;

          this.pendingUpdate = true;
          this.disableQuantitySelector();

          try {
            // R57c: the whole round trip belongs to the controller now. It
            // builds the body from the registry (R57b), fetches, parses,
            // dispatches the one CartUpdateEvent that drives every surface's
            // morph (R56d, R57b) and the one store update that follows it, and
            // re-reads cart state from the server if the response comes back
            // unusable - a 429 with an HTML body, most often. What used to be
            // twenty lines here, and six slightly different versions of the
            // same twenty lines elsewhere, is one call.
            const result = await window.cartController.change(
              { id: lineKey, quantity: committedQuantity },
              { source: 'product-card-alp' }
            );

            // R-TAP, Codex round TAP-11 finding 2. DROP THE QUEUE ON A REFUSAL.
            // The result was thrown away here, so the queued target was replayed
            // whatever happened: a burst of taps past available stock was refused,
            // messaged, and then sent AGAIN for a bigger number that Shopify
            // refuses for exactly the same reason - a second identical banner for
            // one customer action. Same fix, same reasoning, as the one made in
            // component-cart-items.js after round TAP-1; this file was the other
            // half of that pair and was missed.
            if (!result?.ok) {
              this.queuedQuantity = null;
              this.quantity = this.cartProduct?.quantity ?? this.quantity;
            }
          } catch (error) {
            // The controller swallows every failure it knows about and
            // reconciles, so anything arriving here is a genuine surprise.
            // Re-point the visible quantity at the cart we last knew about
            // rather than leaving the optimistic number standing.
            console.error('[product-card-alp] cart change threw unexpectedly', error);
            window.ctrNotifyCartFailure?.(
              'Sorry, your basket could not be updated. Please try again.',
              'product-card-alp',
              error
            );
            this.queuedQuantity = null;
            this.quantity = this.cartProduct?.quantity ?? this.quantity;
          } finally {
            // R57a: this also unsticks the selector when a request throws. It
            // used to be re-enabled only on the happy path, so one failure left
            // the control dead until a reload.
            this.pendingUpdate = false;
            this.enableQuantitySelector();

            if (this.queuedQuantity !== null) {
              const next = this.queuedQuantity;
              this.queuedQuantity = null;

              if (next !== committedQuantity) {
                this.quantity = next;
                this.updateCart();
              }
            }
          }
        },

        onChangeQuantity(event) {
          this.quantity = Number(event.target.value);
          this.updateCart();
        },

        /**
         * @param {number | null} newSellingPlanId
         * @param {number | null} oldSellingPlanId
         */
        handleSellingPlanChange(newSellingPlanId, oldSellingPlanId) {
          if (this.variant.selling_plan_groups?.length > 0) {
            this.sellingPlanId =
              this.variant.selling_plan_groups
                .find((group) => group.app_id === "SKIO")
                ?.selling_plans.find((plan) => plan.id === newSellingPlanId)?.id ||
              null;
            return this.sellingPlanId;
          }

          if (this.variant.selling_plan_allocations?.length > 0) {
            this.sellingPlanId =
              this.variant.selling_plan_allocations?.find(
                /** @param {{selling_plan_id: number | null}} allocation */
                (allocation) => allocation.selling_plan_id === newSellingPlanId
              )?.selling_plan_id || null;
            return this.sellingPlanId;
          }

          this.sellingPlanId = null;
          return this.sellingPlanId;
        },
      }
    });

    /**
     * @param {{product: {selling_plan_groups: Array<{selling_plans: Array<{id: number | null, name: string}>}>}}} product
     * @returns {Array<{id: number | null, name: string}>}
     */
    function getSellingPlan(sellingPlanId) {
      if (variant.selling_plan_allocations?.length > 0) {
        return variant.selling_plan_allocations.map(
          (allocation) => allocation.selling_plan_id
        );
      }

      if (variant.selling_plan_groups?.length > 0) {
        const skioGroup = variant.selling_plan_groups.find(
          (group) => group.app_id === "SKIO"
        );
        if (skioGroup) {
          return skioGroup.selling_plans.map((plan) => ({
            id: plan.id,
            name: plan.name,
          }));
        }
      }

      return [];
    }
});
